module.exports = __webpack_public_path__ + "staticesp/media/ventos.10e5ad88.mp4";